import React, { useEffect } from "react";
import { Modal, Row, Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import "./index.less";

type props = {
  isOpen: boolean;
  onClose?: () => void;
};

const UnlockLinkInfoModalComponent: React.FC<props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header px-20">
          <Typography.Text className="bottom-modal-title">{t("important")}</Typography.Text>
        </div>

        <div className="w-full justify-content-center mt-10">
          <Typography.Text className="unlock-link-info-modal-message">
            {t("unlock-link-info-modal-message")}
            {" → "}"{t("unlock-link")}"
          </Typography.Text>
        </div>

        <div className="bottom-modal-body mb-40">
          <button className="bottom-modal-button" onClick={onClose}>
            <Typography.Text className="bottom-modal-button-title">{t("confirm-btn")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnlockLinkInfoModalComponent;
